import React, { useMemo } from 'react';
import { useFillApplicationButtonClick } from 'shared/containers/stickyButtons/FillApplicationButton/hooks/useFillApplicationButtonClick';
import { TMapOffersResult } from 'shared/types/common/offer';

import { RedesignStickyBarContent } from './components/RedesignStickyBarContent';
import { useRedesignStickyBarState } from './hooks/useRedesignStickyBarState';
import { useScrollToOffers } from './hooks/useScrollToOffers';
import { getOffersSummary } from './utils/getOffersSummary';

export interface IRedesignStickyBarProps {
  mappedOffers: TMapOffersResult;
  offersIsFetching: boolean;
}

export const RedesignStickyBar: React.FC<IRedesignStickyBarProps> = ({ mappedOffers, offersIsFetching }) => {
  const hasOffers = mappedOffers.length > 0;
  const variant = useRedesignStickyBarState({
    hasOffers,
    isFetching: offersIsFetching,
    enabled: true,
  });
  const offersSummary = useMemo(() => getOffersSummary(mappedOffers), [mappedOffers]);
  const handleScrollToOffers = useScrollToOffers(mappedOffers);
  const { handleClick, isPending } = useFillApplicationButtonClick();

  return (
    <RedesignStickyBarContent
      variant={variant}
      paymentText={offersSummary?.paymentText}
      rateText={offersSummary?.rateText}
      bankLogos={offersSummary?.bankLogos}
      onInfoClick={handleScrollToOffers}
      onCtaClick={handleClick}
      isCtaLoading={isPending}
    />
  );
};
